import 'bootstrap/dist/css/bootstrap.min.css';
import { useEffect } from 'react';

import Layout from "../../hocs/layout/Layout";
import NavBar from "../../components/navigation/Navbar";
import Footer from "../../components/navigation/Footer";
import Carousel from "../../components/home/Carrousel";
import Noticias from '../../components/home/Noticias';
import Marcas from '../../components/home/Marcas'
import ContactoDistribuidor from '../../components/home/ContactoDistribuidor';


function Home(){
    useEffect(() => {
                window.scrollTo(0,0)
    },[])
    return(
        <Layout>
            <NavBar/>
            <div className='py-28'>
                <Carousel/>
                <Noticias/>
                <Marcas/>
                <ContactoDistribuidor/>
                <Footer/>
            </div>
        </Layout>

    );
}export default Home;